import { render, staticRenderFns } from "./ListaParticipantes.vue?vue&type=template&id=6d2a5700&scoped=true&"
import script from "./ListaParticipantes.vue?vue&type=script&lang=js&"
export * from "./ListaParticipantes.vue?vue&type=script&lang=js&"
import style0 from "./ListaParticipantes.vue?vue&type=style&index=0&id=6d2a5700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2a5700",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VListItem,VListItemContent,VListItemTitle,VRow,VSimpleTable})
